import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-offline-status",
  "use": "icon-offline-status-usage",
  "viewBox": "0 0 1056 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1056 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-offline-status\"><defs><style type=\"text/css\"></style></defs><path d=\"M532.48 24.576c278.528 0 507.904 221.184 507.904 491.52s-229.376 491.52-507.904 491.52-507.904-221.184-507.904-491.52 221.184-491.52 507.904-491.52z\" p-id=\"3993\" fill=\"#dbdbdb\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol